module.exports = __webpack_public_path__ + "img/confirma-carta.91cfccfc.png";